import React from 'react';
const GroupContext = React.createContext(null);
export default GroupContext;
